import { Card, CardBody, CardHeader } from 'shards-react';

const GhostElement = ({ provided, pageNumber, url, pagesCount }) => {
	return (
		<Card innerRef={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className='border-2 border-success'>
			<CardHeader className='p-0 d-flex'>
				{pagesCount > 1 && <span className='dnd-counter'>{pagesCount}</span>}
				<span className='font-italic mx-auto'>{`Seite: ${pageNumber + 1}`}</span>
			</CardHeader>
			<CardBody className='p-0 text-center'>
				<img className='rounded w-100' alt={`thumbnail-${pageNumber}`} src={url} width='200' height='282' />
			</CardBody>
		</Card>
	);
};

export default GhostElement;
